import React, { Component } from "react";
import DarkModeToggle from "./DarkModeToggle";

class Nav extends Component {
    render() {
        return (
            <div className="nav">
                <div className="nav-group">
                    <div className="nav-item"><a href="/">Home</a></div>
                    <div className="nav-item"><a href="/assets/Resume.pdf">Resume</a></div>
                    <div className="nav-item"><a href="https://github.com/MagnusSiegumfeldt" rel="noreferrer" target="_blank">GitHub</a></div>
                    <div className="nav-item"><a href="https://linkedin.com/in/magnussiegumfeldt" rel="noreferrer" target="_blank">LinkedIn</a></div>
                </div>
                <div className="nav-group">
                    <DarkModeToggle/>
                </div>
            </div>
        )
    }
    
    
}
export default Nav; 